import React from 'react';
import { Dropdown } from '@vtblife/uikit';
import { RegionSelector2Modal } from './RegionSelector2Modal';
import { RegionSelector2Item } from './RegionSelector2Item';
import { RegionSelector2Button } from './RegionSelector2Button';

type RegionSelector2Props = {
    items: ReadonlyMap<RegionSelector2Item['id'], RegionSelector2Item>;
    isMobile?: boolean;
    placeholder?: string;
    dropdown?: boolean;
} & ({
    selectedId?: RegionSelector2Item['id'];
    onSelectId(id?: RegionSelector2Item['id'] | undefined): void;
    hasEmptySelect: true;
} | {
    selectedId: RegionSelector2Item['id'];
    onSelectId(id: RegionSelector2Item['id']): void;
    hasEmptySelect?: undefined | false;
})

export function RegionSelector2({
    selectedId,
    onSelectId,
    items,
    isMobile,
    hasEmptySelect,
    placeholder = 'Регион',
    dropdown = false
}: RegionSelector2Props) {
    const selected = selectedId !== undefined ? items.get(selectedId) : undefined;
    const [ isOpened, setIsOpened ] = React.useState(false);
    const onSelectIdRef = React.useRef(onSelectId);

    onSelectIdRef.current = onSelectId;

    const onSubmit = React.useCallback((id: RegionSelector2Item['id']) => {
        onSelectIdRef.current?.(id);
        setIsOpened(false);
    }, []);

    const title = selected?.displayName?.length ? selected?.displayName : placeholder;

    return (<>
        { dropdown ? (
            <Dropdown.SimpleControl
                arrow
                size='s'
                onToggle={() => setIsOpened(true)}
                opened={isOpened}
                children={title}
                dataTest='region-trigger'
            />
        ) : (
            <RegionSelector2Button
                onClick={() => setIsOpened(true)}
                children={title}
                after='Изменить'
                dataTest='region-trigger'
            />
        )}
        {isOpened && <RegionSelector2Modal
            onSelectId={onSubmit}
            selectedIdInitial={selectedId}
            items={items}
            isMobile={isMobile}
            onClose={() => setIsOpened(false)}
            hasEmptySelect={hasEmptySelect}
        />}
    </>);
}

